import { Component } from "@builder.io/sdk";

export const heroConfig: Component = {
  name: "Hero (Home)",
  screenshot:
    "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F4bb54ad45f354539815f378803f65839",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Your Partner in Exceptional Senior Care",
    },
    {
      name: "subheading",
      type: "longText",
      defaultValue:
        "Personalized care plans and expert staffing solutions for senior citizens in homes and facilities.",
    },
    {
      name: "primaryCta",
      type: "object",
      defaultValue: {
        text: "Get Started",
        href: "/care-assessment",
        ariaLabel: "Go to Care Assessment",
      },
      subFields: [
        {
          name: "text",
          type: "string",
        },
        {
          name: "href",
          type: "string",
        },
        {
          name: "ariaLabel",
          type: "string",
        },
      ],
    },
    {
      name: "secondaryCta",
      type: "object",
      defaultValue: {
        text: "Inquire Now",
        href: "/contact-us",
        ariaLabel: "Go to Inquiry Form",
      },
      subFields: [
        {
          name: "text",
          type: "string",
        },
        {
          name: "href",
          type: "string",
        },
        {
          name: "ariaLabel",
          type: "string",
        },
      ],
    },
    {
      name: "image",
      type: "object",
      defaultValue: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F69f948cb7abf4cdcae3e0e8cd80c056e",
        alt: "A woman with glasses and a black blazer smiles and shakes hands with another person.",
      },
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
        },
        {
          name: "alt",
          type: "string",
        },
      ],
    },
  ],
};
